import type { CloudAllowanceStatus } from "@afar-research/contracts";

import { useConnectSnapshotCheckedOnUse } from "../connection/connectSnapshot";

/**
 * The signed-in account's Cloud allowance, or null when signed out, without a Connect bridge, or
 * before Connect has answered. Read from the Connect snapshot, checked when the page is used.
 */
export function useCloudAllowance(): CloudAllowanceStatus | null {
  return useConnectSnapshotCheckedOnUse()?.allowance ?? null;
}

/** Administrative visibility derives from Connect's current authorization. */
export function useConnectAdmin(): boolean {
  return useCloudAllowance()?.admin === true;
}
